import * as React from 'react';
import { connect } from 'react-redux';
import CompagniaActions from './CompagnieActions';
import * as agui from 'arm-gui/dist/controls';

import { Utils, NumberFormatter, isAuth, domainVal, i18n, DateFormatter } from 'arm-common';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import { AppConstants } from '../../constants/AppConstants';
import { isNullOrUndefined } from 'util';
import { rejects } from 'assert';
import AppActions from '../../app/app_actions';
import MicroCategoriaTable from '../microCategorie/MicroCategoriaTable.jsx';
import BtnDelete from '../shared/BtnDelete.jsx'
import ApplicationData from '../../app/aApplicationData'
import { resolve } from 'path';


class CompagniaDetails extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[CompagniaDetails.jsx] ';
        this.modificaButton = this.modificaButton.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.deleteCompagnia = this.deleteCompagnia.bind(this);
        this.nuovoPuntoVendita = this.nuovoPuntoVendita.bind(this);
        this.indietroButton = this.indietroButton.bind(this);
        this.annullaOnClick = this.annullaOnClick.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.showConfirmPanelPV = this.showConfirmPanelPV.bind(this);
        this.salvaPV = this.salvaPV.bind(this);
        this.deletePuntoVendita = this.deletePuntoVendita.bind(this);
        this.showConfirmDelete = this.showConfirmDelete.bind(this);
        this.state = {
            showConfirmPV: false,
            validation: new Map(),
            showConfirmDelete: false,
            pvDaEliminare: null
        }
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');

        let idCompagnia = null;

        if (isNullOrUndefined(this.props.location.state) || isNullOrUndefined(this.props.location.state.id)) {
            idCompagnia = this.props.compagnia.id;
        } else {
            idCompagnia = this.props.location.state.id;
        }

        console.log(this.componentName + '[ID] ' + idCompagnia);
        let columns = [
            { field: 'id', title: 'ID ', sortable: 'true' },
            // { field: 'nomeEntity', title: 'Nome', sortable: 'false' },
            // { field: 'idEntity', title: 'Id Entita', sortable: 'true' },
            { field: 'denominazione', title: i18n('ARM_CORE_PRODUCT.COMPAGNIE.DENOMINAZIONE', 'Denominazione'), sortable: 'true', formatter: this.tipoAliquotaFormatter },
            { field: 'updateDate', title: i18n('ARM_CORE_PRODUCT.SHARED.ULTIMA_MODIFICA', 'Ultima Modifica'), sortable: 'true', formatter: this.dateFormatter },
            { field: 'updateUser', title: i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da'), sortable: 'true' },
            { field: 'elimina', align: 'center', title: i18n("ARM_CORE_PRODUCT.SHARED.ELIMINA", "Elimina"), formatter: this.columnDelete },
        ];

        $(this.refs.PuntoVenditaTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            sortOrder: "desc",
            pagination: true,
            onClickRow: (row, $element, field) => this.deleteOnClick(row, $element, field),
        });

        //effettuo la chimata rest per recuperare i dati

        this.props.getCompagniaDetails(idCompagnia).then(
            resolve => {
                this.props.getListaPuntiVendita(idCompagnia).then(
                    resolve => {
                    }, reject => {
                        console.log(this.componentName + 'getListaPuntiVendita KO');
                    }
                )
            }, reject => {
                console.log(this.componentName + 'getCompagniaDetails(idCompagnia) KO');
            }
        );
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.puntiVendita !== this.props.puntiVendita) {
            console.log("\t rows: " + (nextProps.puntiVendita !== null ? nextProps.puntiVendita.length : "NULL"));
            $(this.refs.PuntoVenditaTable).bootstrapTable('load', nextProps.puntiVendita);
        }
    }

    deleteOnClick(row, $element, field) {
        console.log(this.componentName + " deleteOnClick()");

        if (field === "elimina") {
            this.inzializzaEliminaPV(row.id);
        }

    }

    columnDelete(value, row, index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

    inzializzaEliminaPV(idPuntoVendita) {

        this.setState({ pvDaEliminare: idPuntoVendita, showConfirmDelete: true });

    }

    showConfirmDelete() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
    }

    deletePuntoVendita() {

        this.showConfirmDelete();

        this.props.deletePuntoVendita(this.state.pvDaEliminare).then(

            resolve => {
                this.props.getListaPuntiVendita(this.props.compagnia.id)
            }
        )
    }

    annullaOnClick() {
        this.showConfirmPanelPV();

        this.props.inizializzaNuovoPuntoVendita();

    }

    showConfirmPanelPV() {
        console.log(this.componentName + 'showConfirmPanelPV');

        this.setState({ showConfirmPV: !this.state.showConfirmPV });


    }

    salvaPV() {
        console.log(this.componentName + 'salvaPV');

        if (!this.validateForm()) {
            return;
        }
        this.showConfirmPanelPV();

        this.props.salvaPV(this.props.compagnia.id).then(

            resolve => {
                this.props.getListaPuntiVendita(this.props.compagnia.id).then(

                    resolve => {
                        $(this.refs.PuntoVenditaTable).bootstrapTable('load', resolve)
                    }
                )
            }
        )



    }

    validateForm() {
        console.log(this.componentName + 'validateForm');
        let validation = new Map();
        let required = ['denominazione'];
        for (let i = 0; i < required.length; i++) {
            if (this.props.puntoVendita.denominazione === undefined || this.props.puntoVendita.denominazione === '' || this.props.puntoVendita.denominazione === null) {
                validation.set(required[0], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        // $("#modalConfirm").modal("close");

        return false;
    }


    modificaButton() {
        console.log(this.componentName + 'modificaButton');
        this.props.history.push({
            pathname: '/compagnie/create', state: {
                id: this.props.compagnia.id,
                modifica: true
            }
        })

    }

    inputChangeHandler(e) {

        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            console.log(this.componentName + "inputChangeHandler:" + id);

            if (this.state.validation.has(id)) {
                this.state.validation.delete(id);
            }

            this.props.inputChangeHandlerPV(id, value);
        }
    }

    indietroButton() {
        console.log(this.componentName + 'indietroButton');
        if (!isNullOrUndefined(this.props.location.state) && this.props.location.state.goBackOfHistory) {
            this.props.history.goBack();
        } else {
            this.props.history.push({
                pathname: '/compagnie/list',
            })
        }

    }

    showConfirmPanel() {
        this.props.showPopUP(!this.props.showConfirm);
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    deleteCompagnia() {
        console.log(this.componentName + 'deleteCompagnia');
        // this.setState({ showConfirm: false });
        this.showConfirmPanel();

        this.props.deleteCompagnia(this.props.compagnia.id).then(
            resolve => {

                this.props.history.push({
                    pathname: '/compagnie/list'
                });

            }, reject => {
                console.log(this.componentName + 'deleteCompagnia KO');
                $('html, body').animate({ scrollTop: 0 }, 1000);
            }
        )


    }

    nuovoPuntoVendita() {
        console.log(this.componentName + "nuovoPuntoVendita: ");
        this.props.inizializzaNuovoPuntoVendita();
        this.showConfirmPanelPV();
    }
    columnDetail(value, row, index) {
        //console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'/></button>";
        return temp;
    }


    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }



    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="card">
                <div className="card-header">
                    <h3> {i18n('ARM_CORE_PRODUCT.COMPAGNIE.DETTAGLIO_COMPAGNIE', 'Dettaglio Compagnia')} {this.props.compagnia.nome} - id {this.props.compagnia.id}</h3>
                </div>
                <div className="card-body">

                    <div>
                        <div className="mt-2 mb-2">
                            {this.props.compagnia ?
                                <div>
                                    <dl className="row">
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.ID', 'id')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.compagnia.id}</dd>
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.COMPAGNIE.DENONINAZIONE', 'Denominazione')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.compagnia.denominazione}</dd>
                                    </dl>

                                    <dl className="row">
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.COMPAGNIE.COD_ANIA', 'Codice Ania')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.compagnia.codAnia}</dd>
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.COMPAGNIE.COD_IVASS', 'Codice IVASS')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.compagnia.codIsVap}</dd>
                                    </dl>

                                    <dl className="row">
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.INSERITO_DA', 'Inserito da')} </dt>
                                        <dd className="col-sm-4 col-6">{this.props.compagnia.insertUser}</dd>
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_INSERIMENTO', 'Data Inserimento')}</dt>
                                        <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.compagnia.insertDate)}</dd>


                                    </dl>
                                    <dl className="row">
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.compagnia.updateUser}</dd>
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_MODIFICA', 'Data Modifica')}</dt>
                                        <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.compagnia.updateDate)}</dd>
                                    </dl>

                                </div>
                                :
                                null
                            }
                        </div>

                        {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                            <agui.aButton className="float-left mt-2" bs='primary' onClick={this.nuovoPuntoVendita} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.COMPAGNIE.PUNTO_VENDITA', 'Punto Vendita')}</agui.aButton>
                        }
                        <table ref="PuntoVenditaTable" className={AppConstants.CLASS_TABLE} />
                    </div>

                </div>
                <div className="card-footer">
                    <div className="float-left">
                        {/* <agui.aButton bs="primary" className="mr-3" icon="fas fa-edit" onClick={this.modificaButton}>{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', 'Modifica')}</agui.aButton> */}
                        {isAuth('V2.ADMIN.PRODUCT.DELETE') &&
                            <BtnDelete onClick={this.showConfirmPanel} className="" ></BtnDelete>
                        }
                        {/* <agui.aButton bs="danger" icon="fas fa-trash-alt" onClick={this.showConfirmPanel} >Elimina</agui.aButton> */}
                    </div>
                    <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.indietroButton} >{i18n('ARM_CORE_PRODUCT.SHARED.INDIETRO', 'Indietro')}</agui.aButton>
                </div>
                <ConfirmModalDeleteV4
                    show={this.props.showConfirm}
                    deleteOnClick={this.deleteCompagnia}
                    onClose={this.showConfirmPanel} />


                <agui.ConfirmModalOkCancelV4 show={this.state.showConfirmPV} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle={i18n('ARM_CORE_PRODUCT.PV.CREAZIONE_PV', 'Nuovo Punto Vendita')} onClose={this.showConfirmPanelPV} />
                    <agui.ConfirmModalOkCancelV4.Body testoBody="">
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="denominazione" type="text"
                                    value={this.props.puntoVendita && this.props.puntoVendita.denominazione}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.DENOMINAZIONE', 'Denominazione')}
                                    onChange={this.inputChangeHandler}
                                    validation={this.state.validation}
                                    name="denominazione"
                                />
                            </div>
                        </div>
                        {/* <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id={"tipo"} type="text"
                                    value={this.props.puntoVendita && this.props.puntoVendita.tipo}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.TIPO', 'Tipo')}
                                    validation={this.state.validation}
                                    onChange={this.inputChangeHandler}
                                    name="tipo"
                                />
                            </div>
                        </div> */}

                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        confirmOnClick={this.salvaPV} onClose={this.annullaOnClick}  
                        testoButtonCancel = {i18n('ARM_CORE_PRODUCT.ANULLA', 'Annulla')} >
                    </agui.ConfirmModalOkCancelV4.Footer>
                </agui.ConfirmModalOkCancelV4>

                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    testoBody={i18n('ARM_CORE_PRODUCT.COMPAGNIA.CONFERMI_ELIMINA_PV', 'Confermi l\'eliminazione del punto vendita con id: ') + this.state.pvDaEliminare}
                    deleteOnClick={this.deletePuntoVendita}
                    onClose={this.showConfirmDelete} />
            </div>
        );
    }
};




function mapStateToProps(state, ownProps) {
    return {
        compagnia: state.compagnie.compagnia,
        showConfirm: state.app.showPopUp,
        puntiVendita: state.compagnie.puntiVendita,
        puntoVendita: state.compagnie.puntoVendita,
    }
}


function mapDispatchToProps(dispatch) {
    return {
        getCompagniaDetails(id) {
            return dispatch(CompagniaActions.getCompagniaDetails(id));
        },
        deleteCompagnia(id) {
            return dispatch(CompagniaActions.deleteCompagnia(id));
        },
        inizializzaNuovoPuntoVendita() {
            return dispatch(CompagniaActions.inizializzaNuovoPuntoVendita())
        },
        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },

        getListaPuntiVenditaDaAssociare(idCompagnia) {
            return dispatch(CompagniaActions.getListaPuntiVenditaDaAssociare(idCompagnia));
        },

        getListaPuntiVendita(idCompagnia) {
            return dispatch(CompagniaActions.getListaPuntiVenditaOfCompagnia(idCompagnia));
        },


        inputChangeHandlerPV(id, value) {
            return dispatch(CompagniaActions.inputChangeHandlerPV(id, value));
        },

        salvaPV(idCompagnia) {
            return dispatch(CompagniaActions.salvaPV(idCompagnia));
        },

        deletePuntoVendita(id) {
            return dispatch(CompagniaActions.deletePuntoVendita(id));
        },

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompagniaDetails);



